export default __webpack_public_path__ + "static/media/cp_geo_gq.1f2b45ca.svg";